export default "__VITE_ASSET__DhZpRb_Q__"